import "./styles/App.css";
import { useContext, useEffect, useState } from "react";
import MyRoutes from "./component/routes";
import { GlobalContext } from "./context/Context";
import AsideBar from "./component/layout/aside";
import { useApiCall } from "./component/custom-hooks/api-call";
import axios from "axios";
import InnerLoader from "./component/ui/loader/inner-loader";

function App() {
  let { state, dispatch } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const checkUser = async () => {
    console.log("Check User Called");
    let userToken = localStorage.getItem("billing_token");
    let userData = JSON.parse(
      localStorage.getItem("billing_user")
    );

    if (!userToken) {
      dispatch({ type: "USER_LOGOUT" });
      return;
    }
    axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;
    try {
      //let apiRes = await apiCall({ url: 'brands/list', method: 'get', customToken: userToken });
      dispatch({ type: "USER_LOGIN", payload: userData, token: userToken });

      getFormData(userToken);
      //  getDropdowns(userToken);
      // if(apiRes?.timeInEnabled == "yes"){
      //   dispatch({ type: 'TIME_OUT', payload: apiRes?.time_activity, hours: apiRes?.hrs });
      // }else{
      //   dispatch({ type: 'TIME_IN', payload: apiRes?.time_activity });
      // }
    } catch (error) {
      console.error("Error : ", error);
    }
  };

  const getDropdowns = async (token) => {
    try {
      let data = {};
      const [d1, d2, d3] = await Promise.all([
        apiCall({
          url: "get-department-list",
          method: "get",
          customToken: token,
        }),
        apiCall({
          url: "get-active-employee-list",
          method: "get",
          customToken: token,
        }),
        apiCall({
          url: "get-employee-shift-list",
          method: "get",
          customToken: token,
        }),
      ]);
      data = {
        departmentList: d1?.departmentList,
        activeEmployeeList: d2?.activeEmployeeList,
        shiftList: d3?.shiftList,
      };
      dispatch({ type: "SET_DROPDOWN", payload: data });
    } catch (error) {
      console.error("Dropdown load error:", error);
    }
  };

  useEffect(() => {
    const checkIsUserLogin = async () => {
      try {
        const apiRes = await axios.get("https://api.ipify.org?format=json");
        dispatch({ type: "SET_IP", payload: apiRes.data.ip });
        checkUser();
      } catch (error) { }
    };
    checkIsUserLogin();
    checkUser();
  }, []);

  // REFUND FORM

  const mapDropdownObjectWithId = (obj = {}) => {
    return Object.entries(obj).map(([key, value]) => ({
      label: value.toString(),
      value: Number(key), // 👈 ID as value
    }));



  };

  const getFormData = async (token) => {
    // let data = {};
    try {
      const [
        // brandProductResponse,
        // merchantResponse,
        // merchantTypeResponse,
        agentResponse,
        dropdownResponse,
      ] = await Promise.all([
        // apiCall({
        //   url: "brands/brands-list",
        //   method: "get",
        //   customToken: token,
        // }),
        // apiCall({
        //   url: "products/products-list",
        //   method: "get",
        //   customToken: token,
        // }),
        // apiCall({
        //   url: "merchants/merchants-list",
        //   method: "get",
        //   customToken: token,
        // }),
        // apiCall({
        //   url: "merchants/merchants-types-list-settings",
        //   method: "get",
        //   customToken: token,
        // }),
        apiCall({
          url: "users/agents-list",
          method: "get",
          customToken: token,
        }),
        apiCall({
          url: "get-dropdowns",
          method: "get",
          customToken: token,
        }),
      ]);

      const yearOptions = Object.entries(dropdownResponse?.data?.year || {}).map(
        ([key, value]) => ({
          label: value.toString(),
          value: Number(key),
        })
      );

      // console.log("Dropdonw" ,dropdownResponse);


      let data = {
        // brandProuductList: brandProductResponse?.data || [],
        // merchantList: merchantResponse?.data || [],
        // merchantTypeList: merchantTypeResponse?.data || [],
        agentList: agentResponse?.agents || [],
        cbOrRefundOptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.cb_or_refund
        ),
        cbOutcomeOptions: mapDropdownObjectWithId(dropdownResponse?.data?.cb_outcome),
        departmentOptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.departments
        ),
        qaStatusOptions: mapDropdownObjectWithId(dropdownResponse?.data?.qa_status),
        quarterOptions: mapDropdownObjectWithId(dropdownResponse?.data?.quarter),
        retentionAttemptOptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.retention_attempt
        ),
        retentionOutcomeOptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.retention_outcome
        ),
        responsibleOptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.responsible
        ),
        sourceOptions: mapDropdownObjectWithId(dropdownResponse?.data?.source),
        workStatusOptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.work_status
        ),
        yearOptions: yearOptions,
        processorReasonOptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.work_status
        ),
        brandoptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.brands
        ),
        merchantoptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.merchants
        ),
        processoroptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.merchant_types
        ),
        productoptions: mapDropdownObjectWithId(
          dropdownResponse?.data?.products
        ),
        businessUnits: mapDropdownObjectWithId(
          dropdownResponse?.data?.business_units
        ),
      };

      dispatch({ type: "SET_DROPDOWN_DATA", payload: data });


    } catch (error) {
      console.warn("Error Modal:", error);
    }
  };

  return (
    <>
      {state.isLogin == true ? (
        <main className="webPage">
          <AsideBar />
          <MyRoutes />
        </main>
      ) : state.isLogin == false ? (
        <MyRoutes />
      ) : (
        <div
          className=""
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* <CircularProgress sx={{ color: "#2563eb" }} size={100} /> */}
          <InnerLoader />
        </div>
      )}

      <svg style={{ display: "none" }}>
        <filter
          id="glass-distortion"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
        >
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.01 0.01"
            numOctaves="1"
            seed="5"
            result="turbulence"
          />

          <feComponentTransfer in="turbulence" result="mapped">
            <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
            <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
            <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
          </feComponentTransfer>

          <feGaussianBlur in="turbulence" stdDeviation="10" result="softMap" />

          <feSpecularLighting
            in="softMap"
            surfaceScale="5"
            specularConstant="1"
            specularExponent="100"
            lightingColor="white"
            result="specLight"
          >
            <fePointLight x="-200" y="-200" z="300" />
          </feSpecularLighting>

          <feComposite
            in="specLight"
            operator="arithmetic"
            k1="0"
            k2="1"
            k3="1"
            k4="0"
            result="litImage"
          />

          <feDisplacementMap
            in="SourceGraphic"
            in2="softMap"
            scale="150"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </svg>
    </>
  );
}

export default App;
